/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useQuery, useReactiveVar } from '@apollo/client';
import { orderBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { getQueryParams, sortIterate } from 'utils';
import { GET_DIMENSIONS, GET_DQ_RULES, GET_QUALITY_DASHBOARD } from 'Apollo/Queries/DataRecon/DataQuality';
import {
    activeDataReconMenuVar, showDataReconMenusVar, leftNavigationItemsVar, tenantIdVar,
    getUserInfoVar, tenantNameVar, currentLeftMenuVar,
} from 'Apollo/config';
import { ModuleEnum } from 'constants';
import crossReportImg from 'assets/images/cross-report-black.svg';
import { setSelectedTenant, setSelectedTenantName } from 'views/Auth/AuthHelper';
import DataQuality from '../components/index';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

/** Columns for DQ Status By Rules Table */
const dqStatusColumns = [
    {
        Header: 'Data Columns',
        accessor: 'columnName',
        minWidth: 100,
        resizable: true,
    },
    {
        Header: 'Rule Name',
        accessor: 'ruleName',
        minWidth: 150,
        resizable: true,
    },
    {
        Header: 'Indicator',
        accessor: 'ruleDescription',
        minWidth: 150,
    },
    {
        Header: 'Row Processed',
        accessor: 'rowsProcessed',
        minWidth: 70,
        resizable: true,
    },
    {
        Header: 'Row Failed',
        accessor: 'rowsFailed',
        minWidth: 70,
    },
    {
        Header: 'DQ Score (in %)',
        accessor: 'score',
        minWidth: 70,
        resizable: true,
    },
];

const DataQualityContainer = () => {
    const history = useHistory();
    const params = getQueryParams();
    const [summaryData, setSummaryData] = useState(null);
    const [rulesRunData, setRulesRunData] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);
    const [showAddRuleModal, setShowAddRuleModal] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isAssignedRulesSaved, setIsAssignedRulesSaved] = useState(false);

    const userInfo = useReactiveVar(getUserInfoVar);
    /* apollo query to fetch data quality summary details */
    const {
        data: dashboardData, error: dashboardError, loading: dashboardLoading, refetch,
    } = useQuery(GET_QUALITY_DASHBOARD, {
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true,
        variables: {
            projectId: parseInt(JSON.parse(params.project).projectId, 10),
            fileName: params.file,
        },
    });

    /* apollo query to fetch data quality rules */
    const { data: rulesData, error: rulesError, loading: rulesLoading } = useQuery(GET_DQ_RULES, {
        variables: {
            projectId: parseInt(JSON.parse(params.project).projectId, 10),
        },
    });

    /* Apollo query to fetch dimensions  */
    const dimensions = useQuery(GET_DIMENSIONS);

    // Getter for dimentionId
    const getDimensionName = dimensionName => {
        let result;
        if (dimensions.data && dimensions.data.DQgetDimensions) {
            result = dimensions.data.DQgetDimensions.find(d => d.dimensionName === dimensionName);
        }
        return result ? result.dimensionId : '';
    };

    /* function to navigate to quality details */
    const navigateToDetails = kpi => {
        const dimentionId = getDimensionName(kpi.title);
        if (kpi.value !== null || kpi.value !== undefined) {
            history.push({
                pathname: '/quality-details',
                state: {
                    dimentionId,
                    qualityDimension: `${kpi.title.charAt(0).toUpperCase() + kpi.title.slice(1)}`,
                    tenantId: params.tenantId,
                    project: JSON.parse(params.project),
                    file: params.file,
                    rowsProcessed: rulesRunData && rulesRunData[0].rowsProcessed,
                    dimScore: dashboardData && dashboardData.DQgetSummary.dimScore,
                    fileDisplayName: params.fileDisplayName,
                },
            });
        }
    };
    /* function to navigate to projects */
    const navigateToProjects = () => history.push({
        pathname: '/projects',
        state: {
            tenantId: params.tenantId,
        },
    });

    /* function to navigate to Data Recon home page */
    const navigateToReconHome = () => history.push(
        {
            pathname: '/data-recon-home',
            state: {
                tenantId: params.tenantId,
            },
        },
    );

    /* function to navigate to back */
    const navigateBack = () => history.push({
        pathname: '/data-lineage-upload',
        state: {
            tenantId: params.tenantId,
            project: JSON.parse(params.project),
            uploadId: params.uploadId,
        },
    });

    /* function to navigate to file upload page/ project details page */
    const navigateToDataLineageUpload = () => history.push({
        pathname: '/data-lineage-upload',
        state: {
            tenantId: params.tenantId,
            project: JSON.parse(params.project),
        },
    });

    // Breadcrumbs items
    const items = [
        {
            link: '',
            value: <span className="appkiticon icon-home-fill font-16" onClick={navigateToReconHome} role="presentation" />,
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text" onClick={navigateToProjects} role="presentation"> Projects </span>,
        },
        {
            link: '',
            value: (
                <span
                    className="a-breadcrumb-item-text"
                    onClick={navigateToDataLineageUpload}
                    role="presentation"
                >
                    {JSON.parse(params.project).projectName}
                </span>
            ),
        },
        {
            link: '',
            value: <span className="a-h6">DQS Dashboard</span>,
        },
    ];

    /* side effect called when component loads */
    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.DATARECONCILIATION);
    }, []);

    /* side effect when dashboardData is available, format the data and set the data to state variable. */
    useEffect(() => {
        if (dashboardData && dashboardData.DQgetSummary) {
            const orderedDimScore = orderBy(dashboardData.DQgetSummary.dimScore, [item => sortIterate(item, 'value')], ['desc']);
            const updatedSummaryData = {
                ...dashboardData.DQgetSummary,
                dimScore: orderedDimScore,
            };
            setSummaryData(updatedSummaryData);
        }
    }, [dashboardData]);

    /* side effect when dashboardData and rulesData is available, format the data and set the data to state variable. */
    useEffect(() => {
        if (dashboardData && dashboardData.DQgetSummary && rulesData && rulesData.DQgetRules) {
            const ruleTableData = dashboardData.DQgetSummary.ruleDetails.map(rd => {
                const ruleDefinition = rulesData.DQgetRules.find(r => r.ruleId === rd.ruleId);
                return {
                    ...rd,
                    ruleName: ruleDefinition.ruleName,
                    ruleDescription: ruleDefinition.ruleDescription,
                    rowsFailed: rd.rowsProcessed - rd.rowsPassed,
                };
            });
            setRulesRunData(ruleTableData);
        }
    }, [dashboardData, rulesData]);

    /* side effect when dashboardLoading and rulesLoading are available, based on values set the dataLoading state variable. */
    useEffect(() => {
        if (dashboardLoading || rulesLoading) {
            setDataLoading(true);
        } else {
            setDataLoading(false);
        }
    }, [dashboardLoading, rulesLoading]);

    /* side effect when dashboarderror or rulesError are available, based on values set the isError state variable. */
    useEffect(() => {
        if (dashboardError || rulesError) {
            setIsError(true);
        } else {
            setIsError(false);
        }
        showDataReconMenusVar(true);
        activeDataReconMenuVar('projects');
    }, [dashboardError, rulesError]);

    /* side effect when assigned rules are saved to DB and Add Rule Modal is closed call the refetch function */
    useEffect(() => {
        if (!showAddRuleModal && isAssignedRulesSaved) {
            refetch();
            setIsAssignedRulesSaved(false);
        }
    }, [isAssignedRulesSaved, showAddRuleModal]);

    useEffect(() => {
        if (params.tenantId) {
            setSelectedTenant(params.tenantId);
            const selectedTenant = userInfo?.getUser?.userTenants.filter(ut => ut.tenantId === parseInt(params.tenantId, 10))[0];
            setSelectedTenantName(selectedTenant?.name);
            tenantIdVar(parseInt(params.tenantId, 10));
            tenantNameVar(selectedTenant?.name);
        }
    }, [params]);

    return (
        <DataQuality
            breadcrumbItems={items}
            dataLoading={dataLoading}
            summaryData={summaryData}
            navigateBack={navigateBack}
            navigateToDetails={navigateToDetails}
            rulesRunData={rulesRunData}
            dataQualityStatusColumns={dqStatusColumns}
            showAddRuleModal={showAddRuleModal}
            setShowAddRuleModal={setShowAddRuleModal}
            params={params}
            isError={isError}
            setIsAssignedRulesSaved={setIsAssignedRulesSaved}
        />
    );
};
export default DataQualityContainer;
